module.exports = __webpack_public_path__ + "img/receipt5.d2c97114.png";